 <template>
    <div class="custom-modal">
        <div v-if="staticModal" class="custom-modal-header">
            <slot name="modal-header">
                <div class="custom-modal-header__header">
                    <div class="custom-modal-header__title">
                        <h3>{{ modalTitle }}</h3>
                    </div>
                    <div class="custom-modal-header__button">
                        <button @click="closeModal" class="close-button d-flex flex-row-reverse">
                            <i class="ion ion-close-circle-outline close-button__icon"></i>
                        </button>
                    </div>
                </div>
                <hr />
            </slot>
        </div>
        <div class="custom-modal-content">
            <br>
            <i><strong> Overweight fee will apply if weight is heavier than below limits:</strong></i>
            <br>
            <br>
            <i><strong>1. Gross Vehicle Weight (GVW) Limit</strong></i>
            <br>
            <i>Maximum legal GVW on the U.S. Interstate system:<strong> 80,000 lbs.</strong></i>
            <br>
            <br>
            <i><strong>2. Axle Weight Limits (Federal Baseline).</strong></i>

            <i style="display:flex; justify-content: center">
                <img src="@/assets/images/drayage-overweigth.png" alt="" style="width:90%;margin: 15px"/>
            </i>
            <br>
            <i ><strong>3. Container Payload Guidelines</strong></i>
            <ul  style="margin: 5px">
                <li>
                     <i><strong>For a 20-foot container:</strong> typical recommended payload weight ~
                    <strong>38,000 lbs</strong>.If weight is heavier Triaxle will apply. If higher than 44.000 lbs overweight permit will apply.</i>
                </li>

                <li>
                     <i><strong>For a 40-foot container:</strong> typical recommended payload weight ~
                    <strong>44,000 lbs</strong>. If weight is heavier Triaxle will apply. If higher than 44.000 lbs overweight permit will apply.</i>
                </li>

                <li>
                     <i><strong>Note:</strong>
                    These payload values assume that the combined weight of tractor + chassis + container +
                    (genset if it is a reefer container)+ cargo still stays under the allowable gross weight and axle limits.</i>
                </li>
            </ul>
            <i><strong>4. Load Distribution & Compliance Checks</strong></i>
            <ul>
                 <i><li>
                    Ensure cargo is distributed so that no single axle or tandem axle group exceeds its legal limit.
                </li></i>
                <i><li>
                    Confirm that the total vehicle (tractor + chassis + container + genset + cargo) does not exceed
                    <strong>80,000 lbs</strong> (or applicable state limit).
                </li></i>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: "CustomModal",
  props: {
    value: Boolean,
    staticModal: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeModalOverweigth", false);
    },
  },
};
</script>

<style lang="scss" scoped>

@use '@/assets/scss/_mixin' as *;

.custom-modal-header {
    .close-button {
        @include modals-close-button;
        padding-right: 0px;
    }
    hr {
        margin-top: 0px;
        margin-bottom: 7px;
    }
    &__header {
        @include modals-header;
    }
    &__title {
        @include modals-title;
        h3 {
            font-size: 1.5rem;
            font-weight: bold;
            @media (width <= 600px) {
                font-size: 1.4rem;
            }
        }
    }
}
.custom-modal-content {
    margin:20px;
    @include font-standart-text;
    color: $color-primary-company;
    hyphens: none;
    word-break: normal;
    overflow-wrap: normal;
    margin-top: 10px;
    font-family: "Montserrat";
    font-size: 0.9rem;
    span {
        font-weight: bold;
        margin-top: 5px;
    }
    li {
        margin-top: 5px;
    }
    img {
        margin-bottom: 20px;
    }
}
</style>
